// const greenPalette = {
//   main: '#B1D2B3',
//   light: '#d2e8d2',
//   dark: '#4F8150'
// };

// export default greenPalette;

const orangePalette = {
  main: '#9ad295',
  light: '#e6f8e3',
  dark: '#4e8e3d'
};

export default orangePalette;